import { tkParse } from '@moke/vue-tk'
/**
 * 发送短信提醒
 * @param arr {array}
 * @param message {string}
 * @returns {Promise<void>}
 */
async function sendMessage (arr, message) {
  // await tkParse.post('/sms/send', {
  //   phone: arr[0],
  //   templateId: '2Y71w1',
  //   vars: {
  //     message: message
  //   }
  // }).catch(e => {
  //   console.log(e)
  //   console.log('发送短信失败')
  // })
  await tkParse.post(`/sendSms/$sendSms`, {
    phone: arr[0],
    message: message
  }).catch(e => {
    console.log(e)
    console.log('发送短信失败')
  })
}
export {
  sendMessage
}
